<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import Vue from "vue";
export default {
  name: "App",
  components: {},
  data() {
    return {};
  },
  created() {
    console.log("VUE Version: " + Vue.version);
    document.title = "Vonage CCTranslation";
    require("@vonagevolta/volta2/dist/css/volta.css");
    require("@vonagevolta/volta2/dist/css/addons/volta-prism.css");
    require("@vonagevolta/volta2/dist/css/volta-templates.css");
    require("@vonagevolta/volta2/dist/symbol/volta-icons.svg");
  },
};

import axios from "axios";
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
